export default "__VITE_ASSET__CQRIxCjz__"